import React, { useEffect, useState } from "react";
import { Table, Button, Tooltip } from "antd";
import { YHModal } from "@/components/YHModal";
import { YhBox } from "@/components/YhBox";
import { IDescription, DescriptionColorEnum } from "@/components/YhBox/Types";
import { ColumnsType, TablePaginationConfig } from "antd/es/table";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from "@/utils/constants";
import { ISearchPage } from "@/types/ScmTypes";
import { sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import useGlobalModel from "@/model/globalModel";
import { transPgToPagination, momentFormat } from "@/utils/utils";
import { commonModuleService, IUserDetail, IUseStatistics, IUserSearch } from "./commonModuleService"
import { convertRes2Blob } from "@/utils/exportFile";
import YhTootip from "@/components/YhTootip";
interface IConSumeHistoryType {
    visible: boolean,
    name: string,
    onCancel: () => void
}
const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

export const ConsumeHistoryModel = ({
    visible,
    name,
    onCancel,
}: IConSumeHistoryType) => {
    const initDesc = {
        amount: 0,
        totalNum: 0,
        inTotal: 0
    }
    const { shopAndOrg } = useGlobalModel(({ shopAndOrg }) => [shopAndOrg]);
    const [dataSource, setDataSource] = useState<IUserDetail[]>([]);
    const [descTotal, setDescTotal] = useState<IUseStatistics>(initDesc);
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [searchParam, setSearchParam] = useState<IUserSearch>({})
    const [loading, setLoading] = useState<boolean>(false);
    useEffect(() => {
        if (visible) {
            loadData(initPgCfg, { userName: name })
            setSearchParam({ userName: name })
        }
    }, [visible])

    const loadData = async (page?: ISearchPage, searchValue: IUserSearch = searchParam) => {
        setLoading(true)
        let searchParams = {
            ...searchValue,
            ...shopAndOrg,
            ...sourceAppOrBranch,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await commonModuleService.userPage(searchParams);
        const { records, statistics, ...pg } = retData
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        setDescTotal(statistics)
        setLoading(false);
    }

    const desc: IDescription[] = [
        {
            label: "应收金额",
            value: descTotal.amount,
            color: DescriptionColorEnum.red
        },
    ]
    const columns: ColumnsType<any> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t, r, i) => i + 1
        }, {
            title: '客户名称',
            width: 120,
            dataIndex: 'userName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '单据编号',
            width: 120,
            dataIndex: 'tradeCode',
        }, {
            title: '单据类型',
            width: 120,
            dataIndex: 'tradeTypeName',
        }, {
            title: '单据日期',
            width: 120,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }, {
            title: '应收金额',
            width: 120,
            dataIndex: 'amount',
        }, {
            title: '制单人',
            width: 120,
            dataIndex: 'billingClerk',

        }
    ]
    const onExport = async () => {
        const searchParams = {
            ...searchParam,
            ...shopAndOrg,
        }
        let result = await commonModuleService.stockIoExport(searchParams);
        convertRes2Blob(result)
    }
    const title = <Button
        className="mr-5"
        type="primary"
        shape="round"
        onClick={onExport}
    >导出</Button >

    return <YHModal
        visible={visible}
        onCancel={onCancel}
        title="消费记录"
        width={'70%'}
        bodyHeight={730}
        showFooter={false}
    >
        <YhBox title={title} descriptions={desc}>
            <Table
                bordered
                loading={loading}
                style={{ cursor: "pointer" }}
                columns={columns}
                dataSource={dataSource}
                pagination={{
                    ...pgCfg,
                    position: ["bottomCenter"],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize }).then();
                    }
                }}
                scroll={{ x: 'max-content', y: 520 }}
            >
            </Table>
        </YhBox>

    </YHModal>
}